import { render, staticRenderFns } from "./changedescdialog.vue?vue&type=template&id=590bf868&scoped=true&"
import script from "./changedescdialog.vue?vue&type=script&lang=js&"
export * from "./changedescdialog.vue?vue&type=script&lang=js&"
import style0 from "./changedescdialog.vue?vue&type=style&index=0&id=590bf868&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590bf868",
  null
  
)

export default component.exports